import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { Link } from "react-router-dom";
import logoAutomahack from "assets/img/automahack-logo.png";

function LoginModal() {
  const [modal, setModal] = useState(true);
  const toggle = () => setModal(!modal);

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop="static">
        <ModalBody className="text-center text-white bg-dark p-4 rounded">
          <div className="d-flex justify-content-center">
            <img src={logoAutomahack} alt="Logo" width={80} className="mt-2 mb-2" />
          </div>
          <h5 className="mt-3 mb-3">
            PARA ACESSAR O AUTOMAPRO <br />
            É <span style={{ color: '#e14eca', fontWeight: "bold" }}>NECESSÁRIO</span> TER UMA CONTA NA <span style={{ color: '#e14eca', fontWeight: "bold" }}>ESPORTIVABET</span>.
          </h5>
          <div className="text-left mt-4">
            <strong>1. Não tenho uma conta.</strong>
            <p style={{color: "rgba(255, 255, 255, 0.8)"}}>
              Caso ainda não tenha uma conta criada na EsportivaBet você pode criar clicando no botão abaixo
            </p>
            <a 
              href="https://go.aff.esportiva.bet/bffv8o29" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-info text-white d-block"
            >
                Criar uma conta
            </a>
          </div>
          <div className="text-left mt-4">
            <strong>2. Já tenho uma conta.</strong>
            <p style={{color: "rgba(255, 255, 255, 0.8)"}}>Caso você já tenha uma conta, clique no botão abaixo e acesse a nossa plataforma.</p>
            <Button color="primary" block onClick={toggle}>Acessar AUTOMAPRO</Button>
          </div>
        </ModalBody>
        <ModalFooter className="bg-dark">
          <small className="text-muted mx-auto">18+</small>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default LoginModal;
